import React, { useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {
  GridSection,
  GridEleven,
  GridLeft,
  GridRight,
  DialogHeader,
  DialogHeading,
} from '../../Episode.Styled';
import Box from '@mui/material/Box';
import {
  dateFormatPdf,
  westCarePdfHeading,
  westCarePdfTitle,
} from '../../../../constants';
import FormTextFieldPdf from '../../../common/Forms/FormTextFieldPdf';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { setCbpAuthPdfPrint } from '../../../../redux/episode/authTab/cbpAuthPdfSlice';
import Button from '@mui/material/Button';
import { useReactToPrint } from 'react-to-print';

const CbpAuthPdfDialog = (props) => {
  const dispatch = useDispatch();
  const { open, setOpen, openCbpAuthPdfBackdrop } = props;
  const cbpAuthPdfForm = useSelector((state) => state?.cbpAuthPdfForm?.data);
  const cbpAuthPdfPrint = useSelector(
    (state) => state?.cbpAuthPdfForm?.cbpAuthPdfPrint
  );

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const participantInformationData = [
    {
      title: 'Name :',
      text: cbpAuthPdfForm?.participantInformation?.name,
    },
    {
      title: 'DOB :',
      text: moment(cbpAuthPdfForm?.participantInformation?.DOB)
        .format(dateFormatPdf)
        .split('T')[0],
    },
    {
      title: 'Parole Date :',
      text: moment(cbpAuthPdfForm?.participantInformation?.paroleDate)
        .format(dateFormatPdf)
        .split('T')[0],
    },
    {
      title: 'Parole Agent :',
      text: cbpAuthPdfForm?.participantInformation?.paroleAgent,
    },
    {
      title: 'Registrant 290 :',
      text: cbpAuthPdfForm?.participantInformation?.registrant290
        ? 'Yes'
        : 'No',
    },
  ];

  const cBPAuthorizationData = [
    {
      title: 'Authorization Start Date :',
      text: moment(cbpAuthPdfForm?.CBPAuthorization?.authorizationStartDate)
        .format(dateFormatPdf)
        .split('T')[0],
    },
    {
      title: 'Authorization End Date :',
      text: moment(cbpAuthPdfForm?.CBPAuthorization?.authorizationEndDate)
        .format(dateFormatPdf)
        .split('T')[0],
    },
    {
      title: 'Number days from Start to End Date :',
      text: cbpAuthPdfForm?.CBPAuthorization?.numberDaysfromStarttoEndDate,
    },
  ];

  const residentialData = [
    {
      title: 'Program Name :',
      text: cbpAuthPdfForm?.resident?.programName,
    },
    {
      title: 'Modality :',
      text: cbpAuthPdfForm?.resident?.modality,
    },
    {
      title: 'Address :',
      text: cbpAuthPdfForm?.resident?.address,
    },
    {
      title: 'City :',
      text: cbpAuthPdfForm?.resident?.city,
    },
    {
      title: 'Zip :',
      text: cbpAuthPdfForm?.resident?.zip,
    },
    {
      title: 'Contact name :',
      text: cbpAuthPdfForm?.resident?.contactName,
    },
    {
      title: 'Phone :',
      text: cbpAuthPdfForm?.resident?.phone,
    },
    {
      title: 'Fax :',
      text: cbpAuthPdfForm?.resident?.fax,
    },
  ];

  const nonresidentialData = [
    {
      title: 'Program Name :',
      text: cbpAuthPdfForm?.nonResident?.programName,
    },
    {
      title: 'Modality :',
      text: cbpAuthPdfForm?.nonResident?.modality,
    },
    {
      title: 'Address :',
      text: cbpAuthPdfForm?.nonResident?.address,
    },
    {
      title: 'City :',
      text: cbpAuthPdfForm?.nonResident?.city,
    },
    {
      title: 'Zip :',
      text: cbpAuthPdfForm?.nonResident?.zip,
    },
    {
      title: 'Contact name :',
      text: cbpAuthPdfForm?.nonResident?.contactName,
    },
    {
      title: 'Phone :',
      text: cbpAuthPdfForm?.nonResident?.phone,
    },
    {
      title: 'Fax :',
      text: cbpAuthPdfForm?.nonResident?.fax,
    },
  ];

  const residentialAdditionalData = [
    {
      title: 'Approved Length of Stay :',
      text: `${cbpAuthPdfForm?.resident?.approvedLengthofStay} days`,
    },
  ];

  const caseManagerConformatationLeftData = [
    {
      title: 'Case Manager Name :',
      text: cbpAuthPdfForm?.caseManagerConfirmation?.caseManagerName,
    },
    {
      title: 'Office Location :',
      text: cbpAuthPdfForm?.caseManagerConfirmation?.officeLocation,
    },
  ];
  const caseManagerConformatationRightData = [
    {
      title: 'Signature :',
      text: '',
    },
    {
      title: 'Date :',
      text: moment(cbpAuthPdfForm?.caseManagerConfirmation?.Date)
        .format(dateFormatPdf)
        .split('T')[0],
    },
  ];

  const supervisorAuthorizationLeftData = [
    {
      title: 'Supervisor Name :',
      text: cbpAuthPdfForm?.superviserAuthorization?.SupervisorName,
    },
    {
      title: 'Supervisor Title',
      text: cbpAuthPdfForm?.superviserAuthorization?.SupervisorTitle,
    },
  ];
  const supervisorAuthorizationRightData = [
    {
      title: 'Signature :',
      text: '',
    },
    {
      title: 'Date :',
      text: moment(cbpAuthPdfForm?.superviserAuthorization?.Date)
        .format(dateFormatPdf)
        .split('T')[0],
    },
  ];

  const handleClose = () => {
    setOpen(false);
    dispatch(setCbpAuthPdfPrint(false));
  };

  //useEffect(() => {
  //  if (cbpAuthPdfPrint) {
  //    window.print();
  //  }
  //}, [cbpAuthPdfPrint]);

  return (
    <Dialog fullScreen open={open} onClose={setOpen}>
      {openCbpAuthPdfBackdrop ? (
        <Backdrop
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={openCbpAuthPdfBackdrop}
        >
          <CircularProgress />
        </Backdrop>
      ) : (
        <>
          <DialogHeader>
            <DialogHeading variant='h5'></DialogHeading>
            <Box>
              <Button variant='contained' onClick={() => handlePrint()}>
                Print
              </Button>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogHeader>
          <Grid container pt={10} ref={componentRef}>
            <GridSection container spacing={2} style={{ alignItems: 'center' }}>
              <Grid item xs={12} sm={9}>
                <Typography variant='h5'>{westCarePdfHeading}</Typography>
                <Typography variant='h6'>{westCarePdfTitle}</Typography>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Typography variant='h6'>
                  Episode ID : {cbpAuthPdfForm?.episodeID}
                </Typography>
                <Typography variant='h6'>
                  STOP Auth ID : {cbpAuthPdfForm?.STOPAuthID}
                </Typography>
              </Grid>
            </GridSection>
            <GridSection container spacing={2}>
              <GridLeft item xs={12} sm={5.5}>
                <Typography variant='h5'>Participant Information</Typography>
                {participantInformationData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                  />
                ))}
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridLeft>
              <GridRight item xs={12} sm={5.5}>
                <Typography variant='h5'>CBP Authorization</Typography>
                {cBPAuthorizationData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                    width={true}
                  />
                ))}
                <p>(This authorization expires 14 days from above date)</p>
              </GridRight>
            </GridSection>
            <GridSection container spacing={2}>
              <Grid item xs={12} sm={11}>
                <FormTextFieldPdf
                  title='Referral Source Information :'
                  defaultValue={cbpAuthPdfForm?.referralSourceInformation}
                  width={true}
                />
                <FormTextFieldPdf
                  title='Referral Organization :'
                  defaultValue={cbpAuthPdfForm?.referralOrganization}
                  width={true}
                />
              </Grid>
            </GridSection>
            <GridSection container spacing={2}>
              <GridLeft item xs={12} sm={5.5}>
                <Typography variant='h5'>
                  Residential/Sober Living Program CBP ID:{' '}
                  <u>{cbpAuthPdfForm?.resident?.CBP}</u>
                </Typography>
                {residentialData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                  />
                ))}
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridLeft>
              <GridRight item xs={12} sm={5.5}>
                <Typography variant='h5'>
                  Non-Residential Program CBP ID :{' '}
                  <u>{cbpAuthPdfForm?.nonResident?.CBP}</u>
                </Typography>
                {nonresidentialData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                  />
                ))}
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridRight>
            </GridSection>
            <GridSection container spacing={2}>
              <GridLeft item xs={12} sm={5.5}>
                {residentialAdditionalData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                    width={true}
                  />
                ))}
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridLeft>
              <GridRight item xs={12} sm={5.5}>
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridRight>
            </GridSection>
            {/**
            <GridSection container spacing={2}>
              <GridLeft item xs={12} sm={11}>
                <Typography variant='h5'>Clinical Information</Typography>
                <Typography variant='h6'>
                  Treatement Recommendations (includes special conditions of
                  parole)
                </Typography>
                <FormTextFieldPdf
                  defaultValue={
                    cbpAuthPdfForm?.clinicalInformation
                      ?.treatmentRecommendations
                  }
                />
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridLeft>
            </GridSection>
            **/}
            <GridSection container spacing={2}>
              <GridEleven item xs={12} sm={11}>
                <Typography variant='h5'>
                  Case Manager Conformatation
                </Typography>
              </GridEleven>
              <GridLeft item xs={12} sm={5.5}>
                {caseManagerConformatationLeftData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                  />
                ))}
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridLeft>
              <GridRight item xs={12} sm={5.5}>
                {caseManagerConformatationRightData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                  />
                ))}
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridRight>
            </GridSection>
            <GridSection container spacing={2}>
              <GridEleven item xs={12} sm={11}>
                <Typography variant='h5'>Supervisor Authorization</Typography>
              </GridEleven>
              <GridLeft item xs={12} sm={5.5}>
                {supervisorAuthorizationLeftData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                  />
                ))}
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridLeft>
              <GridRight item xs={12} sm={5.5}>
                {supervisorAuthorizationRightData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                  />
                ))}
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridRight>
            </GridSection>
          </Grid>
        </>
      )}
    </Dialog>
  );
};

export default CbpAuthPdfDialog;
